import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import * as CategoriesSelectors from '../store/selectors/categories.selector';
import { Observable } from "rxjs";
import { IGetCategoriesItemDto } from "app/main/pages/categories.dto";
import * as CategoryAction from "./actions/categories.actions";

@Injectable({ providedIn: 'root' })

export class CategoryFacade {

    public categories$: Observable<IGetCategoriesItemDto[]> = this._store.select(CategoriesSelectors.allCategories);

    constructor(private _store: Store) {}

    fetchCategories(): void {
        this._store.dispatch(CategoryAction.fetchCategories());
    }
}